import { HOME_DESTINATIONS, HOME_TOOLS, homeDestinationAccess } from './homeDestinations';

const fixedIds = new Set(HOME_TOOLS.map(tool => tool.id));

export function shortcutCardDestinations(home) {
  const selected = new Set(home?.shortcutCards || []);
  return HOME_DESTINATIONS.filter(destination => selected.has(destination.id) && !fixedIds.has(destination.id));
}

export function visibleHomeToolCards(home, canAccess, isQcManager = false) {
  const shortcuts = shortcutCardDestinations(home).map(destination => ({...destination,isShortcut:true}));
  const definitions = [...HOME_TOOLS.map(tool => ({...tool,isShortcut:false})),...shortcuts];
  return (home?.toolOrder || []).map(id => definitions.find(definition => definition.id === id)).filter(card =>
    card && homeDestinationAccess({anyOf:card.anyOf,portal:card.portal || card.id}, canAccess) && (!card.managerOnly || isQcManager)
  );
}
